import React from 'react';
import { useSelector } from 'react-redux';
import { View } from 'modules/styled';
import PushNotification from './notificationBanner';
import BetNotification from './betBanner';

const PROMPT_TYPES = {
  push: PushNotification,
  bet: BetNotification,
};

export default function BannerPrompt() {
  const notif = useSelector((state) => state.notif);
  if (!notif.promptType) return null;

  const Prompt = PROMPT_TYPES[notif.promptType];
  if (!Prompt) return null;

  const { promptProps } = notif;

  return (
    <View
      sx={{
        justifyContent: 'center',
        bg: 'green',
        py: 1,
        px: [2, 4],
      }}
    >
      <Prompt {...promptProps} />
    </View>
  );
}
